<template>
  <div class="relative" v-if="data">
                    
    <button class="absolute inset-0 z-10 flex items-center justify-center w-full bg-transparent group focus:outline-none" @click="isZoomed = true">
      <div class="flex items-center justify-center w-12 h-12 bg-green-100 rounded-full opacity-50 group-focus:bg-white group-hover:bg-white">
        <div class="text-xl leading-none">
          <font-awesome-icon :icon="['far', 'search']" />
        </div>
      </div>
    </button>

    <img :src="`data:image/jpeg;base64, ${data}`" alt="" />    

    <portal to="modals">      
      <div class="fixed inset-0 z-30 flex items-center justify-center p-10 bg-black bg-opacity-75" v-if="isZoomed">
        <button                        
          class="absolute z-30 flex items-center justify-center w-10 h-10 text-gray-900 bg-gray-200 rounded-full shadow-xl top-10 right-10 hover:bg-white focus:bg-white focus:outline-none" 
          @click="isZoomed = null"
          @keypress.esc.prevent.stop="isZoomed = false"
        >
          <font-awesome-icon :icon="['far', 'times']" />
        </button>
        <img class="shadow-lg select-none" :src="`data:image/jpeg;base64, ${data}`" alt="" />
      </div>
    </portal>

  </div>
</template>

<script>
export default {
  
  name: "p-thumbnail-image",
  
  props: {
    data: {
      type: String,
      default: ""
    },
    name: {
      type: String,
      default: ""
    }
  },

  data () {
    return {
      isZoomed: false
    }
  }

}
</script>